import { render } from "./HomeApp.vue?vue&type=template&id=3cef08b8"
import script from "./HomeApp.vue?vue&type=script&lang=js"
export * from "./HomeApp.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__